import { useGetApiV3JobTypes } from '@/libs/api-rest/generated/job-types/job-types';

export const useGetJobTypes = () => {
  return useGetApiV3JobTypes({
    query: {
      enabled: true,
      staleTime: 1000 * 60 * 10
    }
  });
};
